import React, { useState, useEffect } from "react";
import AdminPanel from "../panel/AdminPanel";
import { FaUserPlus, FaTrash, FaEdit, FaSearch } from "react-icons/fa";
import api from "../../../api/api";
import "../styles/UserManagement.css";



const UserManagement = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [searchStudent, setSearchStudent] = useState("");
  const [searchTeacher, setSearchTeacher] = useState("");

  const [students, setStudents] = useState([]);
  const [teachers, setTeachers] = useState([]);

  const [studentForm, setStudentForm] = useState({
    id: null,
    name: "",
    email: "",
    password: "",
    bloodGroup: "",
    address: "",
    parentName: "",
    parentContact: "",
  });

  const [teacherForm, setTeacherForm] = useState({
    id: null,
    name: "",
    email: "",
    password: "",
    contact: "",
  });

  // Fetch students and teachers
  useEffect(() => {
    fetchStudents();
    fetchTeachers();
  }, []);

  const fetchStudents = async () => {
    try {
      const res = await api.get("/api/students");
      const mapped = res.data.map((s) => ({
  ...s,
  id: s._id || s.id,
}));
      setStudents(mapped);
    } catch (err) {
      console.error("Error fetching students:", err);
    }
  };

  const fetchTeachers = async () => {
    try {
      const res = await api.get("/api/teachers");
      const mapped = res.data.map((t) => ({
        ...t,
        id: t._id || Math.random().toString(36).substr(2, 9),
      }));
      setTeachers(mapped);
    } catch (err) {
      console.error("Error fetching teachers:", err);
    }
  };

  const editStudent = (student) => {
    setStudentForm({
      id: student.id || student._id,
      name: student.name || "",
      email: student.email || "",
      password: "",
      bloodGroup: student.bloodGroup || "",
      address: student.address || "",
      parentName: student.parentName || "",
      parentContact: student.parentContact || "",
    });
  };

  const editTeacher = (teacher) => {
    setTeacherForm({
      id: teacher.id || teacher._id,
      name: teacher.name || "",
      email: teacher.email || "",
      password: "",
      contact: teacher.contact || "",
    });
  };

  const handleStudentSubmit = async () => {
    if (!studentForm.name || !studentForm.email || !studentForm.password) {
      alert("Name, Email, and Password are required.");
      return;
    }

    const payload = {
      name: studentForm.name,
      email: studentForm.email,
      password: studentForm.password,
      bloodGroup: studentForm.bloodGroup || "",
      address: studentForm.address || "",
      parentName: studentForm.parentName || "",
      parentContact: studentForm.parentContact || "",
    };

    try {
      if (studentForm.id) {
        await api.put(`/api/students/${studentForm.id}`, payload);
        alert("✅ Student updated successfully");
      } else {
        await api.post("/api/students", payload);
        alert("✅ Student added successfully");
      }

      fetchStudents();
      setStudentForm({
        id: null,
        name: "",
        email: "",
        password: "",
        bloodGroup: "",
        address: "",
        parentName: "",
        parentContact: "",
      });
    } catch (err) {
      if (err.response?.data?.error) {
        alert("❌ " + err.response.data.error);
      } else {
        console.error(err);
        alert("❌ Something went wrong");
      }
    }
  };

  const handleTeacherSubmit = async () => {
    if (!teacherForm.name || !teacherForm.email || !teacherForm.password) {
      alert("Name, Email, and Password are required.");
      return;
    }

    const payload = {
      name: teacherForm.name,
      email: teacherForm.email,
      password: teacherForm.password,
      contact: teacherForm.contact || "",
    };

    try {
      if (teacherForm.id) {
        await api.put(`/api/teachers/${teacherForm.id}`, payload);
        alert("✅ Teacher updated successfully");
      } else {
        await api.post("/api/teachers", payload);
        alert("✅ Teacher added successfully");
      }

      fetchTeachers();
      setTeacherForm({ id: null, name: "", email: "", password: "", contact: "" });
    } catch (err) {
      if (err.response?.data?.error) {
        alert("❌ " + err.response.data.error);
      } else {
        console.error(err);
        alert("❌ Something went wrong");
      }
    }
  };

  const deleteStudent = async (id) => {
    try {
      await api.delete(`/api/students/${id}`);
      fetchStudents();
    } catch (err) {
      console.error("Error deleting student:", err);
    }
  };

  const deleteTeacher = async (id) => {
    try {
      await api.delete(`/api/teachers/${id}`);
      fetchTeachers();
    } catch (err) {
      console.error("Error deleting teacher:", err);
    }
  };

  const filteredStudents = students.filter(
    (s) =>
      s.name.toLowerCase().includes(searchStudent.toLowerCase()) ||
      s.email.toLowerCase().includes(searchStudent.toLowerCase())
  );

  const filteredTeachers = teachers.filter(
    (t) =>
      t.name.toLowerCase().includes(searchTeacher.toLowerCase()) ||
      t.email.toLowerCase().includes(searchTeacher.toLowerCase())
  );

  return (
    <>
      <AdminPanel onToggle={setIsSidebarCollapsed} />
      <div className={`sr-main-content ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <h2>User Management</h2>

        {/* Forms */}
        <div className="user-form-cards">
          {/* Student Form */}
          <div className="user-card">
            <h3>
              <FaUserPlus style={{ marginRight: "8px" }} />
              {studentForm.id ? "Update Student" : "Add Student"}
            </h3>
            <div className="user-form">
              <input
                type="text"
                placeholder="Name"
                value={studentForm.name}
                onChange={(e) => setStudentForm({ ...studentForm, name: e.target.value })}
              />
              <input
                type="email"
                placeholder="Email"
                value={studentForm.email}
                onChange={(e) => setStudentForm({ ...studentForm, email: e.target.value })}
              />
              <input
                type="password"
                placeholder="Password"
                value={studentForm.password}
                onChange={(e) => setStudentForm({ ...studentForm, password: e.target.value })}
              />
              <input
                type="text"
                placeholder="Blood Group"
                value={studentForm.bloodGroup}
                onChange={(e) => setStudentForm({ ...studentForm, bloodGroup: e.target.value })}
              />
              <input
                type="text"
                placeholder="Address"
                value={studentForm.address}
                onChange={(e) => setStudentForm({ ...studentForm, address: e.target.value })}
              />
              <input
                type="text"
                placeholder="Parent Name"
                value={studentForm.parentName}
                onChange={(e) => setStudentForm({ ...studentForm, parentName: e.target.value })}
              />
              <input
                type="text"
                placeholder="Parent Contact"
                value={studentForm.parentContact}
                onChange={(e) => setStudentForm({ ...studentForm, parentContact: e.target.value })}
              />
              <button onClick={handleStudentSubmit}>
                {studentForm.id ? "Update" : "Add Student"}
              </button>
            </div>
          </div>

          {/* Teacher Form */}
          <div className="user-card">
            <h3>
              <FaUserPlus style={{ marginRight: "8px" }} />
              {teacherForm.id ? "Update Teacher" : "Add Teacher"}
            </h3>
            <div className="user-form">
              <input
                type="text"
                placeholder="Name"
                value={teacherForm.name}
                onChange={(e) => setTeacherForm({ ...teacherForm, name: e.target.value })}
              />
              <input
                type="email"
                placeholder="Email"
                value={teacherForm.email}
                onChange={(e) => setTeacherForm({ ...teacherForm, email: e.target.value })}
              />
              <input
                type="password"
                placeholder="Password"
                value={teacherForm.password}
                onChange={(e) => setTeacherForm({ ...teacherForm, password: e.target.value })}
              />
              <input
                type="text"
                placeholder="Contact"
                value={teacherForm.contact}
                onChange={(e) => setTeacherForm({ ...teacherForm, contact: e.target.value })}
              />
              <button onClick={handleTeacherSubmit}>
                {teacherForm.id ? "Update" : "Add Teacher"}
              </button>
            </div>
          </div>
        </div>

        {/* Student List */}
        <div className="user-list-card">
          <h4>Existing Students</h4>
          <div className="user-card-top">
            <div className="search-box">
              <FaSearch />
              <input
                type="text"
                placeholder="Search Students..."
                value={searchStudent}
                onChange={(e) => setSearchStudent(e.target.value)}
              />
            </div>
          </div>
          <div className="scrollable-table">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Blood Group</th>
                  <th>Address</th>
                  <th>Parent Name</th>
                  <th>Parent Contact</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredStudents.map((s) => (
                  <tr key={s.id}>
                    <td>{s.name}</td>
                    <td>{s.email}</td>
                    <td>{s.bloodGroup}</td>
                    <td>{s.address}</td>
                    <td>{s.parentName}</td>
                    <td>{s.parentContact}</td>
                    <td>
                      <button className="edit-btn" onClick={() => editStudent(s)}>
                        <FaEdit /> Update
                      </button>
                      <button className="delete-btn" onClick={() => deleteStudent(s.id)}>
                        <FaTrash /> Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Teacher List */}
        <div className="user-list-card" style={{ marginTop: "30px" }}>
          <h4>Existing Teachers</h4>
          <div className="user-card-top">
            <div className="search-box">
              <FaSearch />
              <input
                type="text"
                placeholder="Search Teachers..."
                value={searchTeacher}
                onChange={(e) => setSearchTeacher(e.target.value)}
              />
            </div>
          </div>
          <div className="scrollable-table">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Contact</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredTeachers.map((t) => (
                  <tr key={t.id}>
                    <td>{t.name}</td>
                    <td>{t.email}</td>
                    <td>{t.contact}</td>
                    <td>
                      <button className="edit-btn" onClick={() => editTeacher(t)}>
                        <FaEdit /> Update
                      </button>
                      <button className="delete-btn" onClick={() => deleteTeacher(t.id)}>
                        <FaTrash /> Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserManagement;
